// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastLibraryCarouselAd-cls1_2xQ","cls2":"PodcastLibraryCarouselAd-cls2_oHS PodcastLibraryCarouselAd-cls1_2xQ"};